<template>
  <div class="auction-header">

    <div class="header-group">

      <h1 class="auction-info">
        Աճուրդներ
        <span class="auction-count">{{ ((currentGroup - 1) * auctionItemsPerPage) + auctionCount }} / {{ auction?.totalAuctions }} </span>
      </h1>

      <div class="auction-badges">
        <div class="auction-badge" :class="['socket-status', { connected: socketConnected }]">
          <div class="icon-wrap">
            <img src="/assets/auction/percent.png">
          </div>
          {{ auction?.step }}
          Նվազագույն քայլի տոկոս
        </div>
        <div class="auction-badge" :class="['socket-status', { connected: socketConnected }]">
          <div class="icon-wrap">
            <img src="/assets/auction/time.png">
          </div>
          <span v-if="auction?.rows?.length">
            {{ timeFormat(auction.rows[0].start_at) }}
          </span>
        </div>
        <div class="auction-badge" :class="['socket-status', { connected: socketConnected }]">
          <div class="icon-wrap">
            <img src="/assets/auction/timer.png ">
          </div>
          {{auction?.duration}} Րոպե
        </div>
        <div class="auction-badge centered" :class="['socket-status', { connected: socketConnected }]">
          Առանց ԱԱՀ
        </div>
      </div>
    </div>

    <div class="how-participate">

      <div class="d-flex align-center pl-3">
        <button class="btn btn-primary" @click="$modal.show('auction-how-to-modal')">
          <span class="how-icon">
            <img src='/assets/auction/info.png'>
          </span>
          <span class="exam-btn-txt">Ինչպես մասնակցել</span>
        </button>
      </div>
    </div>
    <auction-how-to-modal></auction-how-to-modal>
  </div>
</template>

<script>
import AuctionHowToModal from '@/components/modals/AuctionHowToModal.vue'
import auction from '@/mixins/auction'

export default {
  name: 'AuctionHeader',
  components: {AuctionHowToModal},
  mixins: [auction],
  data() {
    return {
    }
  },
  computed: {
    currentGroup() {
        return this.$store.getters['auction/currentGroup']
    },
    auctionCount() {
        return this.$store.getters['auction/auctionCount']
    },
    socketConnected() {
        return this.$store.getters['auction/socketConnected']
    },
    auction() {
        return this.$store.getters['auction/auction']
    },
  },
  methods: {
    timeFormat(date) {
      if (!date) {
        return '';
      }

      return date.split(' ')[1].substring(0, 5);
    }
  },
}
</script>

